const actions = {
  SET_STATE: 'common/SET_STATE',
  SHOW_BUSINES_TYPES: 'common/SHOW_BUSINES_TYPES',
}

export default actions
